import { KPI } from './types';

type AnyType = any; // did it this way to avoid many `any` warnings, now its only used in one place.

type KPIActionConfig = {
  onTrack: {
    lowerLimitPercentage: number;
    action: () => AnyType;
  };
  offTrack: {
    lowerLimitPercentage: number;
    action: () => AnyType;
  };
  critical: {
    action: () => AnyType;
  };
};

export const takeActionBasedOnCurrentProgressKPI = (
  kpi: KPI,
  actions: KPIActionConfig,
) => {
  const { actualTarget, totalTarget, expectedTarget } = kpi || {};

  // Expected progress may vary over time
  const expectedProgressPercentage =
    totalTarget > 0
      ? (actualTarget / (expectedTarget ?? totalTarget)) * 100
      : 0;

  if (expectedProgressPercentage >= actions?.onTrack?.lowerLimitPercentage) {
    return actions?.onTrack?.action();
  } else if (
    expectedProgressPercentage >= actions?.offTrack?.lowerLimitPercentage
  ) {
    return actions.offTrack?.action();
  } else {
    return actions.critical?.action();
  }
};
